module.exports = {
  filterForm: [
    {
      id: 'name',
      label: '角色名称',
      type: 'input',
      placeholder: '必填，不可重复',
      clearable: true,
      isRequired: true,
      width: '500px'
    }, {
      id: 'roleCode',
      label: '角色编码',
      placeholder: '必填，不可重复',
      type: 'input',
      noInsert: true,
      width: '500px'
    }, {
      id: 'enable',
      label: '状态',
      type: 'select',
      isRequired: true,
      width: '500px',
      intValue: 1,
      children: [
        {
          id: 1,
          name: '启用'
        },
        {
          id: 0,
          name: '停用'
        }
      ]
    }, {
      id: 'description',
      label: '描述',
      type: 'input',
      visibleType: 'textarea',
      width: '500px'
    }
  ],
  formRules: {
    name: [
      {
        required: true,
        message: '请选择'
      }
    ],
    roleCode: [
      {
        required: true,
        message: '请选择'
      },
      {
        min: 4,
        max: 4,
        message: '必填，由4位数字组成',
        trigger: 'blur'
      }
    ],
    status: [
      {
        required: true,
        message: '请选择'
      }
    ]
  }
}
